import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip, Container, Card, Row, Col, Button, InputGroup } from "react-bootstrap";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../CommonCSS/SocietyCSS.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';

const AssignKpiTemplate = () => {

  const [empIds, setEmpIds] = useState([]);

  const [employeeRows, setEmployeeRows] = useState([{ emp_id: "" }]);
  const [acadYears, setAcadYears] = useState([]);
  const [acadYear1, setAcadYear1] = useState("");

  const [kpiTemplIds, setKpiTemplIds] = useState([]);
  const [kpiTemplId, setKpiTemplId] = useState("");  
  const [errors, setErrors] = useState({});

  const [mode, setMode] = useState("view");
  const isNewMode = mode === "new";
  const isEntryMode = mode === "entry";

  const isHeaderEnabled = isNewMode;
  const isTableEnabled = isEntryMode;

  useEffect(() => {
    populateDropdowns();
  }, []);

  const populateDropdowns = async () => {
    try {
      setKpiTemplIds([]);
      const res = await axios.get(`${BASE_URL}/api/ddl_KPI_Template`);
      setKpiTemplIds(res.data || []);

      setAcadYears([]);
      const resYears = await axios.get(`${BASE_URL}/api/ddl_years`);
      setAcadYears(resYears.data || []);

    } catch (err) {
      console.error("Template load error", err);
    }
  };


  const handleEmployeeChange = (index, selectedOption) => {
    const updated = [...employeeRows];
    updated[index].emp_id = selectedOption ? selectedOption.value : "";
    setEmployeeRows(updated);
  };

  const handleNew = () => {
    setMode("new");
  };

  const handleClear = () => {

    if (window.confirm("Clear data?")) {
      resetPage();
    }

  };

  const resetPage = () => {

      setMode("view");
      setKpiTemplId(null);
      setAcadYear1("");
      setEmployeeRows([{ emp_id: "" }]);
      setErrors({});
      setEmpIds([]);

  }

  const handleProceed = async () => {

    if (!kpiTemplId || kpiTemplId === '') {
      setErrors({ kpiTemplId: true });
      toast.error("Please select Template");
      return;
    } 

    if (!acadYear1 || acadYear1 === '') {
      setErrors({ acadYear1: true });
      toast.error("Please select Academic Year.");
      return;
    }

    setEmpIds([]);

    const resEmp = await axios.get(`${BASE_URL}/api/ddl_Emp_Kpi_Templ`, { params: { p_Kpi_Templ_Id: kpiTemplId,  p_Acad_Year1: acadYear1} });

    setEmpIds(resEmp.data || []);

    setMode("entry");

  }

  const addRow = () => {

    setEmployeeRows([...employeeRows, { emp_id: "" }]);

  };

  const removeRow = async (index) => {

    try {

    const empId = employeeRows[index].emp_id;

    if (mode === "edit") {
      const confirmDelete = window.confirm("This will permanently delete the record. Do you want to continue?"
      );
      if (!confirmDelete) return;

      const response = await axios.post(`${BASE_URL}/api/delete_EmpId_Template`, {
        p_Template_Id: kpiTemplId,
        p_Acad_Year1: acadYear1,
        p_Emp_Id: empId
      });
      if (response.data.message === '1') {
        toast.success(`Employee Deleted from Template successfully`);
      } else {
        toast.error(`Error deleting Employee from Template`);
      }
    }

    const updated = [...employeeRows];
    updated.splice(index, 1);
    setEmployeeRows(updated);

    if (mode === "edit" && employeeRows.length === 0) {
      resetPage();
    }

  } catch (err) {
    toast.error(`Unable to Delete Employee from Template.`);
    console.log(`Technical Error. `, err);
  }

  };

  const handleSave = async () => {

    if (!kpiTemplId) {
      setErrors({ kpiTemplId: true });
      toast.error("Please select Template");
      return;
    }

    if (!acadYear1 || acadYear1 === '0') {
      setErrors({ acadYear1: true });
      toast.error("Please select Academic Year");
      return;
    }

    for (let i = 0; i < employeeRows.length; i++) {

      if (!employeeRows[i].emp_id) {
        setErrors({ rowErrors: { [i]: { emp_id: true } } });
        toast.error(`Please select Employee at Row # ${i + 1}`);
        return;
      }

    }

    const uniqueEmpIds = new Set();

    for (let i = 0; i < employeeRows.length; i++) {

      if (uniqueEmpIds.has(employeeRows[i].emp_id)) {
        setErrors({ rowErrors: { [i]: { employeeRows: true } } });
        toast.error(`Duplicate Employee Id at row ${i + 1}`);
        return;
      }

      uniqueEmpIds.add(employeeRows[i].emp_id);

    }

    const isConfirmed = window.confirm("Save Template for Employee(s) ?");
    if (!isConfirmed) return;

    const payload = {
      template_id: kpiTemplId,
      academic_year1: acadYear1,
      employees: employeeRows
    };

    try {

      const response = await axios.post(`${BASE_URL}/api/save_Template_Emp`, payload);

      if (response.data.message === '1') {
        toast.success(`Template assigned successfully`);
        resetPage();
      } else {
        toast.error(`Error saving Template for Employee`);
      }

    } catch (err) {

      console.error(err);
      alert("Error assigning template");

    }

  };

  const handleEdit = async () => {

    if (!kpiTemplId || kpiTemplId === '') {
      setErrors({ kpiTemplId: true });
      toast.error("Please select Template");
      return;
    }

    if (!acadYear1 || acadYear1 === '') {
      setErrors({ acadYear1: true });
      toast.error("Please select Academic Year.");
      return;
    }

    const response = await axios.get(`${BASE_URL}/api/get_EmpId_Template_Edit`, 
                                        { params: { p_Template_Id: kpiTemplId, p_Acad_Year1: acadYear1 } });

    if (response.data && response.data.length > 0) {
      setEmpIds([]);
      const resEmp = await axios.get(`${BASE_URL}/api/ddl_Employees`);
      setEmpIds(resEmp.data || []);
      setEmployeeRows(response.data);
      setMode("edit");
    } else {
      toast.error("No Employee Assigned in the selected Template.")
    }

  };

  const options = kpiTemplIds.map(code => ({
    value: code.templ_id,
    label: code.templ_name
  }));

  const options_emp = empIds.map(code => ({
    value: code.emp_id,
    label: code.emp_name
  }));

  return (

    <Container fluid className="p-3">

      {/* Header */}

      <Card className="mb-3 p-3">

        <Row className="mb-3">

          <Col md={1}>
            <label>Template</label>
          </Col>

          <Col md={5}>

            <Select
              name="kpiTemplId"
              options={options}
              className={`${errors.kpiTemplId ? "is-invalid" : ""}`}
              value={options.find(option => option.value === kpiTemplId) || null}
              onChange={selectedOption => setKpiTemplId(selectedOption ? selectedOption.value : null)}
              isDisabled={!isHeaderEnabled}
              placeholder="-- Select KPI Template For Edit --"
            />

          </Col>

          <Col md={3} style={{ width: "400px" }}>
            <InputGroup>
              <InputGroup.Text style={{ width: "150px" }}>
               Academic Year 
              </InputGroup.Text>
              <select
                className={`form-select ${errors.acadYear1 ? "is-invalid" : ""}`}
                name="acad_year1"
                value={acadYear1}
                disabled={!isHeaderEnabled}
                onChange={(e) => {setAcadYear1(e.target.value); setErrors({});}}
              >
                <option value="0">-- Select Academic Year--</option>
                {acadYears.map(year => (
                  <option key={year.year1} value={year.year1}>{year.disp_year}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={2}>
            <Button
              variant="primary"
              disabled={!isHeaderEnabled}
              onClick={handleProceed}
            >
              Proceed Employee
            </Button>
          </Col>

        </Row>

        {/* Buttons */}

        <div className="d-flex justify-content-end gap-2 flex-wrap">

          <Button
            style={{ width: "130px" }}
            variant="primary"
            onClick={handleNew}
            disabled={mode !== "view"}
          >
            New
          </Button>

          <Button
            style={{ width: "130px" }}
            variant="secondary"
            onClick={handleClear}
            disabled={mode === "view"}
          >
            Clear
          </Button>

          <Button
            style={{ width: "130px" }}
            variant="primary"
            onClick={handleEdit}
            disabled={!isHeaderEnabled}
          >
            Edit
          </Button>

          <Button
            style={{ width: "130px" }}
            variant="success"
            onClick={handleSave}
            disabled={mode !== "entry"}
          >
            Save
          </Button>

        </div>

      </Card>

      {/* Employee Table */}

      <Card className="p-3">

        <div style={{ minHeight: '220px' }} className="table-wrapper">

          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">

            <thead>
              <tr>
                <th style={{ width: "60%" }}>Employee Name</th>
                <th style={{ width: "10%" }}></th>
              </tr>
            </thead>

            <tbody>

              {employeeRows.map((row, index) => (

                <tr key={row.emp_id}>

                  <td style={{ textAlign: "left" }}>
                    <Select name="emp_id"
                      options={options_emp}
                      value={options_emp.find(option => String(option.value) === String(row.emp_id)) || null}
                      onChange={(selectedOption) => handleEmployeeChange(index, selectedOption)}
                      isDisabled={!isTableEnabled} 
                      placeholder="-- Select Employee --"
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                    
                  </td>

                  <td style={{ textAlign: "center" }}>
                    {(employeeRows.length > 1 || mode === "edit") && (
                      <Button
                        variant="danger"
                        disabled={mode === "view"}
                        size="sm"
                        onClick={() => removeRow(index)}
                      >
                        Delete
                      </Button>
                    )}
                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

        <div className="d-flex justify-content-end mt-2">
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="add-tooltip" style={{ backgroundColor: "#e9ecef" }}>Add Row</Tooltip>}
          >
            <Button
              variant="primary"
              onClick={addRow}
              disabled={!isEntryMode}
              style={{
                width: "45px",
                height: "45px",
                borderRadius: "50%",
                padding: "0",
                fontSize: "30px"
              }}
            >
              +
            </Button>
          </OverlayTrigger>
        </div>

      </Card>

    </Container>
  );

};

export default AssignKpiTemplate;
